import {Api, Method} from "../../api/api";

const VisibleStatus = {
  SHOW: `SHOW`,
  HIDE: `HIDE`,
};

const MIN_PASSWORD_LENGTH = 6;

class Password {
  private api = new Api();

  private readonly formElement: HTMLFormElement;
  private errorHintElement: HTMLElement;
  private submitButton: HTMLElement;
  private answerElement: HTMLElement;
  private preloaderElement: HTMLElement;
  private successElement: HTMLElement;
  private errorElement: HTMLElement;
  private readonly passwordInputElements: NodeListOf<HTMLInputElement>;

  private readonly actionUrl;

  constructor(selector) {
    this.formElement = document.querySelector(selector);
    this.errorHintElement = this.formElement.querySelector(`.js-password-hint`)!;
    this.submitButton = this.formElement.querySelector(`.js-password-submit`)!;
    this.answerElement = this.submitButton.querySelector(`.js-answer`)!;
    this.preloaderElement = this.answerElement.querySelector(`.js-answer-preloader`)!;
    this.successElement = this.answerElement.querySelector(`.js-answer-success`)!;
    this.errorElement = this.answerElement.querySelector(`.js-answer-error`)!;
    this.passwordInputElements = this.formElement.querySelectorAll(`[data-validate-type="password"]`);

    this.actionUrl = this.formElement.action;

    this.onFormSubmit = this.onFormSubmit.bind(this);
  }

  init() {
    this.formElement.addEventListener(`submit`, this.onFormSubmit);
  }

  private getFormData() {
    return new FormData(this.formElement);
  }

  private setVisibleStatusAnswerError(status: string) {
    switch (status) {
      case VisibleStatus.SHOW:
        this.errorElement.classList.add(`show`);
        break;
      case VisibleStatus.HIDE:
        this.errorElement.classList.remove(`show`);
        break;
    }
  }

  private setVisibleStatusHintError(status: string) {
    switch (status) {
      case VisibleStatus.SHOW:
        this.errorHintElement.classList.add(`profile__hint--show`);
        break;
      case VisibleStatus.HIDE:
        this.errorHintElement.classList.remove(`profile__hint--show`);
        break;
    }
  }

  private validateForm() {
    for (const element of this.passwordInputElements) {
      if (element.value.length < MIN_PASSWORD_LENGTH) {
        element.classList.add(`error`);
        return false;
      } else {
        element.classList.remove(`error`);
      }
    }

    return true;
  }

  private resetAnswer() {
    setTimeout(() => {
      this.answerElement.classList.remove(`show`);
      this.setVisibleStatusAnswerError(VisibleStatus.HIDE);
      this.preloaderElement.classList.remove(`hide`);
      this.successElement.classList.remove(`show`);
    }, 3000);
  }

  private async post() {
    return await this.api.customQuery(this.actionUrl, {method: Method.POST, query: this.getFormData()});
  }

  private showAnswer(status) {
    this.preloaderElement.classList.add(`hide`);

    if (status === 200) {
      this.setVisibleStatusAnswerError(VisibleStatus.HIDE);
      this.setVisibleStatusHintError(VisibleStatus.HIDE);

      this.successElement.classList.add(`show`);
      this.formElement.reset();
    } else if (status === 400) {
      this.setVisibleStatusAnswerError(VisibleStatus.SHOW);
      this.setVisibleStatusHintError(VisibleStatus.SHOW);
    } else {
      this.setVisibleStatusAnswerError(VisibleStatus.SHOW);
    }

    this.resetAnswer();
  }

  async onFormSubmit(evt) {
    evt.preventDefault();

    if (this.validateForm()) {
      this.answerElement.classList.add(`show`);

      const {status, answer} = await this.post();

      this.showAnswer(status);
    }
  }
}

export {Password};
